import styled from 'styled-components';
import {Link} from "react-router-dom";
import {FaBuilding} from "react-icons/fa";
import {BsHouseFill} from "react-icons/bs";
import {BiBuildings} from "react-icons/bi";

import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';

const ManutencaoServicos = () => {

    useEffect(()=> {
        Aos.init({duration: 1000});
    },[]);

  return (
    <Container>
        <Header>
            <Title>Manutenção e Reparos</Title>
            <BottomLine></BottomLine>
        </Header>
        <Grid>

            <GridItem data-aos="fade-right">
                
                <Link to={"/servicos/residencial"}>
                    <Img>
                        <ImgInside src="http://www.organizemeucondominio.com.br/site/content/images/2018/04/manutencao-predial-entenda.jpg">
                        </ImgInside>
                    </Img>
                </Link>
                <GridItemTitle>Manutenção Residencial <Icon><BsHouseFill /></Icon></GridItemTitle>
                <GridItemText>
                Cuidados e reparos com os sistemas elétricos, hidráulicos e estruturais, substituição de telhas, instalação de rufos, calhas e pingadeiras, pintura, troca de pisos e revestimentos e reforma geral. Entre em contato com a Remold Serviços Construções e agende uma reunião conosco para que possamos esclarecer suas dúvidas.
                </GridItemText>
                <Button>Saiba Mais</Button>
            </GridItem>

            <GridItem data-aos="fade-right">

                <Link to={"/servicos/predial"}>
                    <Img>
                        <ImgInside src="https://minhaportaria.com/wp-content/uploads/2020/11/manutencao-predial.jpg">
                        </ImgInside>
                    </Img>
                </Link>
               
                <GridItemTitle>Manutenção Predial  <Icon><FaBuilding /></Icon></GridItemTitle>
                <GridItemText>
                Cuidados e reparos com os sistemas elétricos, hidráulicos e estruturais, instalação de barras acessíveis, construção de rampas, instalação de corrimãos, Instalação de piso tátil, Adequação de rampas e calçadas, restauração e pintura de fachada ou interna, troca de pisos e revestimentos, manutenção predial e reforma geral.
                </GridItemText>
                <Button>Saiba Mais</Button>
            </GridItem>

            <GridItem data-aos="fade-right">

                <Link to={"/servicos/condominio"}>
                    <Img>
                        <ImgInside src="https://www.intersept.com.br/wp-content/uploads/2017/10/manutencao-predial-02.png">
                        </ImgInside>
                    </Img>
                </Link>
                <GridItemTitle>Manutenção de Condomínio <Icon><BiBuildings /></Icon></GridItemTitle>
                <GridItemText>
                Cuidados e reparos com os sistemas elétricos, hidráulicos e estruturais, troca de lâmpadas leds para economia de energia, restauração e pintura de fachada e portaria, construção de rampas, instalação de corrimãos, instalação de piso tátil, adequação de rampas e calçadas, troca de pisos, revestimentos e reforma geral. A Remold Serviços Construções se preocupa por você!.
                </GridItemText>
                <Button>Saiba Mais</Button>

            </GridItem>
        </Grid>
    </Container>
  )
}

const Container = styled.div`
    padding: 0px 20px;
    padding-bottom: 20px;

    @media (min-width: 780px) {
        padding: 0px 50px;
        padding-bottom: 50px;
    }
`;

const Header = styled.header`
    margin-bottom: 25px;
`;

const Title = styled.h2`
    color: #494544;
    font-size: 2rem;
    font-weight: 400;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const BottomLine = styled.div`
    background-color: #f2c70f;
    height: 3px;
    width: 50px;
    margin-top: 10px;
    border-radius: 35px;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 40px;

    @media (min-width: 780px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`

const GridItem = styled.div`
    margin-bottom: 50px;

    @media (min-width: 780px) {
        margin-bottom: 0;
    }
`

const Img = styled.div`
    height: 300px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;

    @media (min-width: 780px) {
        height: 200px;
    }

    @media (min-width: 1100px) {
        height: 300px;
    }
`

const Icon = styled.span`
    color: #494544;
    /* margin-bottom: 15px;
    margin-top: 15px; */
    font-size: 1.1rem;
    margin-left: 5px;
    /* display: flex;
    align-items: center;
    justify-content: center; */
`;

const ImgInside = styled.img`
    height: 100%;
    width: 100%;
    object-fit: cover;
    transition: transform 500ms ease-out;

    @media (min-width: 780px) {
        &:hover {
            transform: scale(120%);
        }
    }
   
`;

const GridItemTitle = styled.h3`
    color: #494544;
    font-size: 1.3rem;
    font-weight: 700;
    margin-top: 15px;
    margin-bottom: 10px;
`
const GridItemText = styled.p`
    color: #5b5b5b;
    font-size: 1.1rem;
    line-height: 1.6rem;
`

const Button = styled.div`
    background-color:  #f2c70f;
    border: 2px solid #f2c70f;
    width: fit-content;
    color: #fff;
    text-transform: uppercase;
    font-size: 1.2rem;
    font-weight: 600;
    padding: 6px 18px;
    cursor: pointer;
    border-radius: 5px;
    margin-top: 20px;

    &:hover {
        background-color: #fff;
        color: #f2c70f;
    }
    
`;



export default ManutencaoServicos